function ResetPassword({ handleResetChange, handleResetSubmit, resetForm, formErrors}) {

  return (
    <>
      <form onSubmit={handleResetSubmit} className="sign-up-form">
        <label className="label-forgot-email">What is your email?</label>
        {resetForm.email ?
          <span className="su-errors">{formErrors.email}</span>
        : null}
        <input 
          className="sign-up-form-input"
          type="text" 
          name="email" 
          placeholder="Email" 
          value={resetForm.email} 
          readOnly
        />

        <label className="label-forgot-email">{resetForm.sec_question}</label>
        {resetForm.email ?
          <span className="su-errors">{formErrors.email}</span>
        : null}
        <input 
          className="sign-up-form-input"
          type="password" 
          name="sec_answer" 
          placeholder="Security Question Answer" 
          value={resetForm.sec_answer} 
          readOnly
        />

        <label className="label-forgot-email">What is your new password?</label>
        {resetForm.email ?
          <span className="su-errors">{formErrors.email}</span>
        : null}
        <input 
          className="sign-up-form-input"
          type="password" 
          name="password" 
          placeholder="Password" 
          onChange={handleResetChange}
          value={resetForm.password}
        />
        
        <button className="sign-up-submit-button" onClick={handleResetSubmit}>Submit</button>
      </form>
    </>
  )
}

export default ResetPassword
